module.exports = __webpack_public_path__ + "img/security-time.06431fef.svg";